import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericDelete } from '@/_shared/types/swagger';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_PATH_KEY } from '@/swagger/constants/contents-likes-keys';
import { KEY_DELETE_CONTENTS_LIKES, API_DELETE_CONTENTS_LIKES } from '../constants';
import { MOCK_RESPONSE_DELETE_CONTENTS_LIKES } from '../mocks';

export type RequestDeleteContentsLikes = GenericDelete<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_PATH_KEY
>['request']['path'];

export type ResponseDeleteContentsLikes = GenericDelete<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_PATH_KEY
>['response']['body'];

export type CallParamsDeleteContentsLikes = Omit<RequestDeleteContentsLikes, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseDeleteContentsLikes = ResponseDeleteContentsLikes;

type CallErrorDeleteContentsLikes = {
  message: string;
  code: number;
};

type CallSelectorsDeleteContentsLikes = unknown;

export const deleteContentsLikesCall = createGeneralCall<
  CallParamsDeleteContentsLikes,
  CallResponseDeleteContentsLikes,
  CallErrorDeleteContentsLikes,
  CallSelectorsDeleteContentsLikes
>({
  id: KEY_DELETE_CONTENTS_LIKES,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_DELETE_CONTENTS_LIKES(org as unknown as string, payload.contentHash);
    },
  method: 'delete',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_DELETE_CONTENTS_LIKES : undefined,
});
